import { useRouter } from 'next/router';

const RedirectPage = ({ route }: Record<string, string>) => {
  const router = useRouter();
  router.push(route);
  return null;
};

export default RedirectPage;
